<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ZCnbB6/tc-custom/9781614235392.jpg?1706155633083" alt="This image is the cover for the book Ghosts of Bristol, Haunted America"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Ghosts of Bristol, Haunted America
      </h1>
      <p class="bookDescription body article font2">
        <b>“A whirlwind ride through the spooky and supernatural, including a ghostly Civil War leftover” (<i>SWVA Today</i>).</b><br/>  <br/> The nighttime glow of the Cameo Theatre illuminates an apparition of the infamous madam Pocahontas Hale, and the ghost of a young Confederate soldier rises from Cedar Hill to gaze mournfully on his lost homestead—these are the haunts of the Twin Cities. Local author Bud Phillips takes readers on an eerie, and sometimes humorous, journey through the ghostly lore of Bristol, Virginia and Tennessee. From the terrifying specter of a headless hobo and the spirits of a young couple parted through violence and reunited in death to the organist who played the Sunday after her funeral, Phillips’s collection of tales raises the otherworldly residents of Bristol from the shadows.<br/>  <br/> Includes photos!
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        V.N. "Bud" Phillips
      </h2>
      
      <p class="authorDescription body article">V.N. &ldquo;Bud&rdquo; Phillips has been a resident of Bristol, Virginia, since 1953. He first began to hear strange and unique stories about the past from his older clients when he served as a social worker. In March 2006, he began writing a detailed history column for the sesquicentennial celebrations of Bristol, and due to popular demand, he continues to write for the <I>Bristol Herald Courier</I> to this day. Now, yielding to request and pressure, he has decided to fill the need for a collection of ghost tales.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Haunted America
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5901d425